import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { ToolSetOptions, ToolSetOptionsItem } from '../../../../../components/ToolSet';
import Link from '../../../../../components/SEO/Link';
import { toHTMLId } from '../../../../../utils/commonHelper';
import messages from '../../../../../utils/translationMessages';
import * as urlHelpers from '../../../../../utils/urlHelpers/boats';
import { getBoatsConstants } from '../../../../../constants/boats/index';
import { PortalConfigContext } from '../../../../../config/portal';

class FilterHullMaterial extends PureComponent {
  state = {
    selectedHullTypes: this.props.selectedHullTypes ? this.props.selectedHullTypes : []
  }

  updateMultiInput() {
    if (this.props.selectedHullTypes !== undefined) {
      this.setState({ selectedHullTypes: this.props.selectedHullTypes });
    }
  }

  updateHullMaterialList(hullType) {
    const { selectedHullTypes } = this.state;
    let newHullTypes;
    if (includes(selectedHullTypes, hullType)) {
      newHullTypes = selectedHullTypes.filter((material) => { return material !== hullType; });
    } else {
      newHullTypes = [...selectedHullTypes, hullType];
    }
    return newHullTypes;
  }

  handleToggleHullType(hullType) {
    const { selectedHullTypes } = this.state;
    const selectedHullTypesSizeBeforeUpdate = selectedHullTypes.length;
    const newHullTypes = this.updateHullMaterialList(hullType);
    this.setState({ selectedHullTypes: newHullTypes });
    if (this.props.tracking) {
      if (selectedHullTypesSizeBeforeUpdate > newHullTypes.length) {
        this.props.tracking.facetRemoved(`hull material removed - ${hullType}`);
      } else {
        this.props.tracking.facetAdded({ hullMaterial: [hullType] });
      }
    }
    this.props.handleDataChange('hullMaterial', newHullTypes);
  }

  componentDidMount() {
    this.updateMultiInput();
  }

  componentDidUpdate() {
    this.updateMultiInput();
  }

  renderHullFilter = (urlId, value, translatedName) => {
    const { params } = this.props;
    const { selectedHullTypes } = this.state;
    const nameId = toHTMLId(urlId);

    const materialValue = getBoatsConstants().HULL_MATERIAL_MAPPING.value[value] ?
      getBoatsConstants().HULL_MATERIAL_MAPPING.value[value] : value;
    const materialUrlId = getBoatsConstants().HULL_MATERIAL_MAPPING.urlId[urlId] ?
      getBoatsConstants().HULL_MATERIAL_MAPPING.urlId[urlId] : urlId;

    return (
      <ToolSetOptionsItem
        type="checkbox"
        key={`hull-${nameId}`}
        id={`hull-${nameId}`}
        name={`hull-${nameId}`}
        value={materialValue}
        selected={includes(selectedHullTypes, materialUrlId)}
        onClick={val => this.handleToggleHullType(val)}
      >
        <Link
          className={`class-${nameId}-link`}
          href={urlHelpers.generateSearchPath(
            { hullMaterial: this.updateHullMaterialList(materialValue) },
            params,
            true,
          )}
          onClick={(e) => e.preventDefault()}
        >
          {translatedName}
        </Link>
      </ToolSetOptionsItem>
    );
  }

  render() {
    const { hullTypes, intl: { formatMessage: t } } = this.props;

    const hullFilters = hullTypes.filter((facet) => {
      return facet.count;
    }).sort((facetA, facetB) => {
      const hullNameA = t(messages.hullMaterialFacetText[facetA.value]);
      const hullNameB = t(messages.hullMaterialFacetText[facetB.value]);
      return hullNameA > hullNameB ? 1 : -1;
    }).map((facet) => {
      const hullName = t(messages.hullMaterialFacetText[facet.value]);
      let unslugifiedFacet = urlHelpers.unslugify(facet.urlId, '+', '-');
      unslugifiedFacet = urlHelpers.unslugify(unslugifiedFacet, '--', '-');

      return this.renderHullFilter(unslugifiedFacet, facet.value, hullName);
    });

    return (
      <div className="search-filter hull-material">
        { hullTypes.length ? (
          <ToolSetOptions>
            { hullFilters }
          </ToolSetOptions>
        ) : null }
      </div>
    );
  }
}

FilterHullMaterial.contextType = PortalConfigContext;

FilterHullMaterial.propTypes = {
  handleDataChange: PropTypes.func.isRequired,
  hullTypes: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    urlId: PropTypes.string,
    value: PropTypes.string
  })),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    hullMaterial: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string
    ])
  }),
  selectedHullTypes: PropTypes.arrayOf(PropTypes.string),
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired,
  }),
};

export default injectIntl(FilterHullMaterial);
